/**
 * Returns the maximum `id` from an array of objects that have a numeric `id`
 * field. Uses `reduce` instead of `Math.max(...arr.map(...))` to avoid the
 * spread-into-call-args pattern, which can hit the call-stack limit for very
 * large arrays and returns `-Infinity` for empty ones.
 *
 * Returns `fallback` (default 0) when the array is empty.
 */
export function maxId<T extends { id: number }>(arr: T[], fallback = 0): number {
  return arr.reduce((max, item) => (item.id > max ? item.id : max), fallback);
}
